import { render, staticRenderFns } from "./addDemoRoleDialog.vue?vue&type=template&id=40e61aa7&scoped=true"
import script from "./addDemoRoleDialog.vue?vue&type=script&lang=js"
export * from "./addDemoRoleDialog.vue?vue&type=script&lang=js"
import style0 from "./addDemoRoleDialog.vue?vue&type=style&index=0&id=40e61aa7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e61aa7",
  null
  
)

export default component.exports